import moment from 'moment/moment';
import * as Output from '../../Text';

export const birthDate = (v) => {
  if (!v) {
    return undefined;
  }

  const date = moment(v, 'YYYY-MM-DD', true);

  if (!date.isValid()) {
    return Output.resolve('generic.errors.M004a_dateFormat');
  }

  if (date.isAfter(moment(), 'date')) {
    return Output.resolve(
      'generic.errors.M004b_dateCanNotBeInTheFuture',
    );
  }

  if (date.isAfter(moment().subtract(18, 'years'))) {
    return Output.resolve(
      'generic.errors.M005:18_MinAge18Years',
    );
  }

  return undefined;
};
